module.exports = __webpack_public_path__ + "img/01.511990f6.png";